'use client';

import React, { useEffect } from 'react';
import { useSessionContext } from '@users/session/SessionContext';
import TwoFactorAuthenticationModal from './TwoFactorAuthenticationModal/TwoFactorAuthenticationModal';
import TwoFactorAuthenticationContext from './TwoFactorAuthenticationContext';

interface IProps {
  children: React.ReactNode,
}

const TwoFactorAuthentication = ({ children }: IProps) => {
  const {
    isTwoFactorAuthenticationRequired,
    setIsTwoFactorAuthenticationRequired,
    logout,
    currentUser,
    session,
  } = useSessionContext();

  useEffect(() => {
    if (!currentUser && !session) {
      setIsTwoFactorAuthenticationRequired(false);
    }
  }, [currentUser, session]);

  const handleModalClose = () => {
    logout({ autoLogout: true, redirect: true });
  };

  const handleSuccess = () => {
    setIsTwoFactorAuthenticationRequired(false);
  };

  return isTwoFactorAuthenticationRequired() ? (
    <TwoFactorAuthenticationModal
      isVisible
      onClose={ handleModalClose }
      successCallback={ handleSuccess }
      showOverlay={ false }
      currentUser={ currentUser }
    />
  ) : children;
};

export default (props: React.ComponentProps<typeof TwoFactorAuthentication>) => (
  <TwoFactorAuthenticationContext>
    <TwoFactorAuthentication { ...props } />
  </TwoFactorAuthenticationContext>
);
